import ActividadTile from './ActividadTile';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaCalendarAlt, FaPercent } from 'react-icons/fa';
import { RoleLayout, RoleGrid, RoleTile } from './RoleShell';

export default function Rrpp() {
  const navigate = useNavigate();

  return (
    <RoleLayout
      title="Panel — RRPP"
      subtitle="Aquí puedes gestionar tus reservas y revisar el detalle de tus comisiones."
      roleLabel="Rol: RRPP"
    >
      <RoleGrid>
        <ActividadTile/>
        <RoleTile
          icon={FaCalendarAlt}
          label="Reservas"
          description="Crea y gestiona reservas para tus invitados."
          onClick={() => navigate('/dashboard/rrpp/reservas')}
        />
        <RoleTile
          icon={FaPercent}
          label="Comisiones"
          description="Consulta tus comisiones por evento y fecha."
          onClick={() => navigate('/dashboard/rrpp/comisiones')}
        />
      </RoleGrid>
    </RoleLayout>
  );
}
